import request from './index'

export async function getObjectList() {
  return request.get('/object/list')
}

export async function upload(file, filename) {
  const form = new FormData()
  form.append('file', file)
  if (filename) form.append('filename', filename)
  return request.put('/object/upload', form)
}

export async function uploadURL(url, filename) {
  const payload = { url, filename }
  return request.post('/object/upload-url', payload)
}

export async function remove(objectId) {
  return request.post(`/object/delete?objectId=${objectId}`)
}

export async function getStatistic() {
  return request.get('/object/statistic')
}